import { Role } from "../../enums/role";
import { IRegion } from "../../interface/filters";

export interface MeUser {
  agent: null | string;
  brand: string;
  csiProfile: Role;
  csiLevel: string;
  dealerInfo: DealerInfo[] | null;
  dealer: string;
  dealerGroup: (string | null)[];
  dealerName: string;
  defaultLocale: string;
  distributor: string[] | null;
  elementBrandColor: string;
  email: string;
  firstBrandColor: string;
  market: string;
  menu: MenuItem[];
  outlet: string;
  pathbrand: string;
  profileCodeMenu: string;
  region: string;
  roles: string[];
  scope: string;
  scopeEntities: { network: any; vehicle: any };
  secondBrandColor: string;
  subRegion: string;
}

export interface DealerInfo {
  dealerId: string;
  dealerName: string;
}

export interface MenuItem {
  children: MenuItem[];
  disable: string;
  displayName: string;
  iconName: string;
  idItem: string;
  itemType: string;
  menuScope: MenuItem[];
  name: string;
  route: string;
}

export class MeUser implements MeUser {
  constructor(user: any) {
    for (let key in user) {
      if (user[key] && typeof user[key] === "string") {
        user[key] = user[key].trim();
      }
    }
    Object.assign(this, user);
    if (this.dealerGroup && Array.isArray(this.dealerGroup)) {
      this.dealerGroup = this.dealerGroup
        .filter((group) => !!group)
        .map((group) => group?.trim()) as string[];
    }
  }
}

export const userHasRoles = (user: MeUser, ...roles: Role[]): boolean => {
  let passedCheck = false;
  for (const role of roles) {
    if (passedCheck) break;
    passedCheck = user.roles.includes(role);
  }
  return passedCheck;
}
export const userHasCsiProfile = (user: MeUser, ...roles: Role[]): boolean => roles.includes(user.csiProfile)
export const userInRegion = (user: MeUser, ...regions: string[]): boolean => regions.includes(user.region)
export const userHasEReputationMax = (user: MeUser | null | undefined): boolean => !!user?.roles?.includes("E-REPUTATION-MAX")
